import { useQuery } from "@apollo/client";
import "../Profiles/profileStyles.css";
import dp from "../../images/ls1.png";
import cp from "../../images/cv.jpg";
import moment from 'moment';
import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { lensClient} from "../../client/LensClient";
import { PublicationType } from "@lens-protocol/client";
import { GET_PUBLICATIONS } from "../../graphql/getPublications";
import { GET_PROFILES_BY_ADDRESS } from "../../graphql/getProfiles";
import {useAddress,MediaRenderer} from "@thirdweb-dev/react";
import { AddReaction } from "../../components/PostInteractions/addReaction";
import { Collect } from "../../components/PostInteractions/collect";
import { Mirror } from "../../components/PostInteractions/mirror";
import { Link } from "react-router-dom";
import {TailSpin} from 'react-loader-spinner';

export default function MyProfile(){
  
  const {id} = useParams();
  const [data, setData] = useState();
  const [posts,setPosts] = useState();

  useEffect(()=>{
      async function fetchProfiles(){
        const profileByHandle = await lensClient.profile.fetch({
          forProfileId: id,
        })
        setData(profileByHandle);
        const result = await lensClient.publication.fetchAll({
          where: {
            from: [id],
            publicationTypes:[PublicationType.Post]
          },
        });
        setPosts(result.items);
      }
      fetchProfiles();
  },[data,posts])

    // v1 method for fetching profile and posts

    // const {data:p_data,loading:p_loading,error:p_error} = useQuery(GET_PROFILES_BY_ADDRESS,{
    //     variables:{
    //       request:{ownedBy:[address]},
    //     },
    //   });

    // const {data:po_data,loading:po_loading,error:po_error} = useQuery(GET_PUBLICATIONS,{
    //     variables:{
    //       request:{
    //         profileId: p_data?.profiles?.items[0].id,
    //         publicationTypes: ["POST"],
    //         limit: 25
    //       },
    //     },
    //   })

    return(
      <div className="profilePage">      
      <div className="">
        {data==null?<div className="spinner">
            <TailSpin height={150}></TailSpin>
      </div>:
        <>
      {data.metadata?.coverPicture?.optimized?.uri==null?
        <img src = {cp} className="banner"
            alt = {data.handle?.localname}/>
        :
       <img src = {data.metadata.coverPicture.optimized.uri} className="banner"
       alt = {data.handle?.localname}/>
      }
  <div className="profile">
    <div className="profileLeft">
    {data.metadata?.picture?.optimized?.uri==null?
        <MediaRenderer src = {dp} alt = {data.handle?.localname} className="profileImg"/>
        :
        <MediaRenderer src = {data.metadata?.picture?.optimized?.uri} className="profileImg"
            alt = {data.handle?.localname}/>
    }
     
    <div className="info">
        <div className="pname">{data[0]?.metadata?.displayName || "Anonymous User"}</div>
        <div className="phandle">{data?.handle?.localName|| ""}</div>
        <div className="pbio">{data?.metadata?.bio || "anonymous"}</div>
        <div className = "attr">
        {data.metadata?.attributes?.map((itm)=>(
          <>
          <div className = "follow">
            <div>{itm.key}:</div>
            <div>{itm.value}</div>
          </div>
          </> 
        ))}
      </div>
        <div className="follow">
          <div>Followers:</div>
          <div>{data.stats.followers}</div>
        </div>
        <div className="follow">
          <div>Following:</div>
          <div>{data.stats.following}</div>
        </div>
        <div className = "editBtn">
            <button> <Link to= {`/edit/${id}`}>Edit Your Profile</Link></button>
        </div>
      </div>
    </div>
    <div className="profileRight">
      <div className="postsType">
        <div className="tab">
          <Link to = {`/myprofile/${id}`}>My Posts</Link>
          <Link to={`/myprofile/nfts/${id}`} > My Nfts</Link>
          <Link to = {`/myProfile/mirrors/${id}`}>My Mirrors</Link>
          <Link to = {`/post/${id}`}>New post</Link>
          <Link to = "/conference">Meeting Room</Link>
        </div>
      </div>

    {posts==null?<div className="spinner">
            <TailSpin height={150}></TailSpin>
      </div>:<>
      {posts!=null?<>
    {posts.map((publication) =>(
            <>
            <div className="card">
            <div className="feedPostHeader">

                {publication.by.metadata?.picture?.optimized?.uri==null?
                 <MediaRenderer src = {dp} className="feedPostProfilePicture" 
                 alt = {publication.by.handle?.fullHandle}/>
                :
                <MediaRenderer src = {publication.by.metadata?.picture?.optimized?.uri} className="feedPostProfilePicture"
                    alt = {publication.by.handle?.fullHandle}/>
                }

            <div className="pos">posted by </div>
            <div className="name">
                <Link to = {`/profile/${publication.by.id}`}>{publication.by.handle?.localName}</Link>
            </div>
            <div className="updated">
                <p> about {moment(publication.createdAt).fromNow()}</p>
            </div>
            </div>
            <div className="feed">
                <h4 className="feedTitle">{publication.metadata?.content}</h4>
            {publication.metadata?.attachments==null?
            null:
            <>
            {publication.metadata?.attachments?.length==0?null:
                <>{publication.metadata?.attachments[0]?.audio?<MediaRenderer src={publication.metadata?.attachments[0]?.audio?.optimized?.uri} className="feedImage"
                alt={publication.metadata?.attachments?.content || ""}/>
                  :
                <>
                {publication.metadata?.attachments[0]?.video?
                <MediaRenderer src={publication.metadata?.attachments[0]?.video?.optimized?.uri} className="feedImage"
                        alt={publication.metadata?.attachments?.content || ""}/>
                :<MediaRenderer src={publication.metadata?.attachments[0]?.image?.optimized?.uri} className="feedImage"
                alt={publication.metadata?.attachments?.content || ""}/>}
                </>
                  }
            </>}</>} 
            </div>
            <div className="feedPostFooter">
                <p> <AddReaction id = {[publication.id,id]}/>{publication.stats?.upvotes}</p>
                <p> <Collect id = {[publication.id,id]}/>{publication.stats?.collects}</p>
                <p> <Mirror id = {[publication.id,id]}/>{publication.stats?.mirrors}</p>
            </div>
        </div>
        </>
        ))}</>:<div  className="notfound"><h2>You have no posts yet.</h2></div>}
        </>}
    </div>
    </div>
    </>
    }
  </div>
  </div>
  );
}